import { render, staticRenderFns } from "./garbageDeliveryTypeList.vue?vue&type=template&id=1b80e646"
import script from "./garbageDeliveryTypeList.vue?vue&type=script&lang=js"
export * from "./garbageDeliveryTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports